module.exports = __webpack_public_path__ + "static/channel-7f80bc16c64003c99ae4916a22d34fcf.gif";